import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GrantedAccessModel } from '@models/granted-access-model';

export const GrantedAccessSchemaV2Actions = createActionGroup({
    source: 'Granted Access Schema V2',
    events: {
        'Reset State': emptyProps(),
        'load Granted Access Schema V2': emptyProps(),
        'load Granted Access Schema V2 Success': props<{
            grantedAccessList: GrantedAccessModel.GrantedAccessDocument[];
        }>(),
        'load Granted Access Schema V2 Fail': emptyProps(),
        'revoke Access': props<{ id: string }>(),
        'revoke Access Success': props<{ grantedAccess: GrantedAccessModel.GrantedAccessDocument }>(),
        'revoke Access Fail': emptyProps(),
    },
});